import { makeObservable, action, computed, observable, IObservableArray } from 'mobx';
import { HospitalOrganizationsSearchStore } from '@hospital/stores';
import { ClientConfigurationModel, IOrganizationListingModel } from '@common/models/.';
import { UserStore } from './UserStore';
export interface UserLocationsAddStoreInit {
    configuration: ClientConfigurationModel
    userStore: UserStore
}

export class UserLocationsAddStore {
    userStore!: UserStore;
    configuration!: ClientConfigurationModel;
    currentCorpOrg!: IOrganizationListingModel;
    hospitalOrgSearchStore!: HospitalOrganizationsSearchStore;
    @observable selectedOrganizations: IObservableArray<IOrganizationListingModel> = observable([]);

    constructor(init: UserLocationsAddStoreInit) {

        const {
            configuration,
            userStore,
        } = init;

        this.configuration = configuration;
        this.userStore = userStore;


        if (!this.userStore)
            throw 'Attempt to instantiate UserLocationsAddStore with undefined UserStore.';

        this.currentCorpOrg = this.configuration.currentCorpOrganization;
        const userId: number | undefined = this.userStore.user && this.userStore.user.userId > 0 ? this.userStore.user.userId : undefined; //use will be loaded by this point because child router outlet doesn't render until it's loaded.
        this.hospitalOrgSearchStore = new HospitalOrganizationsSearchStore(this.configuration, { uid: userId, unrelated: userId ? 1 : undefined }); //unrelated: 1 tells the Hospital Org Search stored procedure to drop org results the specified user id is already related to, so it returns orgs they don't already have.

        makeObservable(this, undefined, { autoBind: true });
    }

    @action.bound clear = () => {
        this.selectedOrganizations.clear();
        this.hospitalOrgSearchStore.setPartialDefaultSearchFilter({});
    }

    @action.bound addSelectedOrganization(organization: IOrganizationListingModel) {
        this.selectedOrganizations.push(organization);
    }

    @action.bound removeSelectedOrganization(organization: IOrganizationListingModel) {
        this.selectedOrganizations.remove(organization);
    }

    isSelectedOrganization(organization: IOrganizationListingModel) {
        return this.selectedOrganizations.filter((org) => {
            return org.organizationId === organization.organizationId;
        }).length > 0;
    }

    @computed get isLoading() {
        return this.hospitalOrgSearchStore.isLoading;
    }
}
